<template>
    <div>
        <sa-icon name=common-icon-border-add />
        <p>---------------------------------</p>
        <sa-common-icon-add1 :config="{theme: 'filled'}" style="font-size: 30px; color: red;"  />
    </div>
</template>
<script>
export default {
    data() {
        
    }
}
</script>
